<template>
<div id="foot">
  <section class="city-contact-section features4 mbr-parallax-background" id="features4-b" data-rv-view="377" data-jarallax-original-styles="null">
        <div class="container" >
        <div class="media-container-row">
            <div class="card p-3 col-12 col-md-6 col-lg-4">
                <div class="card-wrapper">
                    <div class="city-footer-cards">
                        <h3 class="card-title pb-3  display-5">
                            REPORT SANITARY SEWER OVERFLOWS</h3>
                        <p class="city-footer-font display-7">
                            To report sanitary sewer overflows call <a class="city-footer-link" href="tel:361-826-2489">(361) 826-2489</a> Monday through Friday from
                            7 a.m. to 6 p.m. For emergencies, weekends and holidays, call <a class="city-footer-link" href="tel:361-826-1888">(361) 826-1888.</a></p>
                    </div>
                </div>
            </div>

            <div class="card p-3 col-12 col-md-6 col-12 col-md-6 col-lg-4">
                <div class="card-wrapper">
                    <div class="city-footer-cards">
                        <h3 class="card-title pb-3 mbr-fonts-style display-5">WATER UTILITIES</h3>
                        <p class="mbr-text city-footer-font display-7">
                        <a class="city-footer-link" href="https://www.cctexas.com/billing">Pay Your Bill&nbsp;></a><br><br>
                        <a class="city-footer-link" href="https://www.cctexas.com/departments/water-department">Water Department &nbsp;></a><br><br>
                        <a class="city-footer-link" href="https://www.cctexas.com/departments/wastewater">Wastewater Department&nbsp;></a><br><br>
                        <a class="city-footer-link" href="https://www.cctexas.com/departments/services/about-ubo">Utility Business Office&nbsp;></a><br><br>
                        </p>
                    </div>
                </div>
            </div>

            <div class="card p-3 col-12 col-md-6 col-lg-4">
                <div class="card-wrapper">
                    <div class="city-footer-cards">
                        <h3 class="card-title pb-3 mbr-fonts-style display-5">CONNECT</h3>
                        <p class="mbr-text city-footer-font display-7">

                            <a href="https://www.facebook.com/citygov/">
                           <img src="../index_files/images/facebook.svg" alt="Facebook Icon" class="mr-1 mb-3"></a>

                            <a href="https://twitter.com/cityofcc">
                           <img src="../index_files/images/twitter.svg" alt="Twitter Icon" class="mr-1 mb-3"></a>

                           <a href="https://www.youtube.com/user/CCTVCorpusChristi">
                           <img src="../index_files/images/youtube.svg" alt="Youtube Icon" class="mr-1 mb-3"></a>
                        </p>
                    </div>
                </div>
            </div>  
        </div>
    </div>
  </section>
</div>
</template>

<script>
export default {
  name: 'foot',
  data () {
    return {

    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/Foot.vue